export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/education.9859943.svg";